import { TemperatureUnits } from "./generated/graphqlClient";
// static implements CustomUnitTypeStatics<number> (see below)
export class Temperature {
    constructor(valueInCelsius) {
        this.valueInCelsius = valueInCelsius;
    }
    //
    // Conversion and presentation capabilities as statics for optimized use
    //
    static fromPreferredUnits(valueInPreferredUnits, userPreferences) {
        if (userPreferences.temperatureUnits === TemperatureUnits.Fahrenheit) {
            return ((valueInPreferredUnits - 32.0) * 5.0) / 9.0;
        }
        return valueInPreferredUnits;
    }
    static toPreferredUnits(valueInCelsius, userPreferences) {
        if (userPreferences.temperatureUnits === TemperatureUnits.Fahrenheit) {
            return (valueInCelsius * 9.0) / 5.0 + 32.0;
        }
        return valueInCelsius;
    }
    static toString(valueInCelsius, userPreferences) {
        return (Temperature.toPreferredUnits(valueInCelsius, userPreferences).toFixed(1) +
            Temperature.unitsToString(userPreferences));
    }
    static unitsToString(userPreferences) {
        if (userPreferences.temperatureUnits === TemperatureUnits.Fahrenheit) {
            return "\u00B0F";
        }
        return "\u00B0C";
    }
    //
    // Conversion capabilities as members when boxing is required for type detection
    //
    toPreferredUnits(userPreferences) {
        return Temperature.toPreferredUnits(this.valueInCelsius, userPreferences);
    }
    toString(userPreferences) {
        return Temperature.toString(this.valueInCelsius, userPreferences);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error TS6133 /* declared but its value is never read */
const _customUnitTypeStaticsValidation = Temperature;
//# sourceMappingURL=Temperature.js.map